import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/faq";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/faq")(withAlternates(routeOptions, "/faq"));
